module.exports = "/default/fonts/vendor/lightgallery.js/dist/lg.svg?c066c5448562b3ccaefb6408ce4b4ae1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightgallery.js/dist/fonts/lg.svg?n1z373
// module id = cs78
// module chunks = 0